import { useApi } from "../api";
import { createAdminCrudApi } from "../createAdminCrudApi";
import { DECK_ADMIN_URL } from "./deckAdminUrl";
import { SearchSecondaryItemsResponse, UpdateSecondaryItemBody } from "./types/secondaryItems";

export const useDeckSecondaryItemsApi = () => {
  const crud = createAdminCrudApi<SearchSecondaryItemsResponse, never, UpdateSecondaryItemBody>(
    useApi(),
    DECK_ADMIN_URL,
    "secondary_items",
  );

  return {
    useDeckSecondaryItems: crud.useSearch,
    getDeckSecondaryItems: crud.search,
    updateDeckSecondaryItem: crud.update,
    generateUploadImageUrl: crud.generateUploadImageUrl,
    uploadImage: crud.uploadImage,
  };
};

export default useDeckSecondaryItemsApi;
